import { computed, Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AppShellService {
  private readonly sideNavOpenBacking = signal(false);
  sideNavOpen = computed(() => this.sideNavOpenBacking());
  sideNavTransition = signal<'default' | 'end' | 'start'>('default');

  toggleSideNav() {
    this.sideNavOpenBacking.update((isOpen) => !isOpen);
  }

  setSideNavOpenState(open: boolean) {
    this.sideNavOpenBacking.set(open);
  }
}
